import { GET_ORGANIZATIONAL_UNIT_INFO, UPDATE_UNIT_TREE, GET_CATEGORY_EXCLUSIONS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
import { parseResponse } from '@jweb-development/response-parser'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getOrgUnitInfo = (unitID, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId } = getState().auth
      // const { userRoleSupervisors } = getState().userListings
      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data } = await response.json()
        if (!data || !data.unitID) { return fireFailure() }

        const results = { ...data, key: unitID }

        dispatch({
          type: GET_ORGANIZATIONAL_UNIT_INFO,
          payload: results
        })

        fireSuccess()
      } else {
        log.warn('non 200 status code from units')
        fireFailure()
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}

export const updateOrgUnitInfo = (info, unitID, fireSuccess, fireFailure) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId } = getState().auth

      const body = { ...info }

      const options = {
        method: 'PATCH',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        fireSuccess()
      } else {
        fireFailure()
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}

export const createNewUnit = (info, ancestorID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...info, createdBy: supervisorID, ancestorID }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
    } else {
      const { data } = await response.json()

      log.debug(data)
      if (data.unitTree) {
        const { unitTree } = data

        dispatch({
          type: UPDATE_UNIT_TREE,
          payload: unitTree
        })
      }

      fireSuccess()
    }
  }
}

export const deleteUnit = (unitID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { deletedBy: supervisorID }

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
    } else {
      const { data } = await response.json()

      log.debug(data)
      if (data.unitTree) {
        const { unitTree } = data

        dispatch({
          type: UPDATE_UNIT_TREE,
          payload: unitTree
        })
      }

      fireSuccess()
    }
  }
}

export const updateUnitMonitoring = (info, unitID, monitoringID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...info }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(
      `${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/monitoring/schedule/${monitoringID}`, options
    ))

    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const updateOrgUnitAdvancedInfo = (info, unitID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...info }
    const options = {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/advanced`, options))

    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const getUnitCategoryExclusions = () => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/categories`, options))

    if (!response.status || response.status === 500 || response.status === 400 ||
      response.status === 404 || response.status === 401) {
      log.warn('non 200 status code from units')
    } else {
      const { data } = await response.json()

      dispatch({
        type: GET_CATEGORY_EXCLUSIONS,
        payload: data
      })
    }
  }
}

export const updateUnitCategoryExclusions = (info, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    // info = {unitID, categoriesToAdd, categoriesToDelete}

    const body = {
      unitID: info.unitID,
      categoriesToAdd: info.categoriesToAdd,
      categoriesToDelete: info.categoriesToDelete,
      supervisorID
    }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/categories/exclusions`, options))

    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}
